import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { MarketButton, MarketButtonGroup } from '@market/react';
import { getEnv } from 'utilities/environment';

const AdminProductLinks = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { product } = props;

  if (getEnv() === 'production' || !product.contentful_link) {
    return null;
  }

  return (
    <MarketButtonGroup
      alignment="fill"
      style={{ background: theme.color.orange }}
    >
      <MarketButton
        rank="tertiary"
        href={product.shop_admin_link}
        target="_blank"
        style={{ color: theme.color.white }}
      >
        {t('productPage.goToShopAdmin')}
      </MarketButton>
      <MarketButton
        rank="tertiary"
        href={product.contentful_link}
        target="_blank"
        style={{ color: theme.color.white }}
      >
        {t('productPage.editCopy')}
      </MarketButton>
    </MarketButtonGroup>
  );
};

export default AdminProductLinks;
